<template>
  <div class="qy">
    <div class="qy1">
      <div id="charts-1"></div>
    </div>
    <div class="qy2">
      <div id="charts-2"></div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts/core'
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
} from 'echarts/components'
import { PieChart } from 'echarts/charts'
import { LabelLayout } from 'echarts/features'
import { CanvasRenderer } from 'echarts/renderers'

echarts.use([
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  PieChart,
  CanvasRenderer,
  LabelLayout,
])

export default {
  name: 'qyfw', //企业服务
  data() {
    return {
      charts1: {
        title: '咨询企业数量',
        subTitle: '50家',
        data: [
          { value: 27, name: '工业(27)' },
          { value: 8, name: '批零售或外贸(8)' },
          { value: 3, name: '港航物流业(3)' },
          { value: 2, name: '房地产(2))' },
          { value: 5, name: '住宿业(5)' },
          { value: 2, name: '餐饮业(2)' },
          { value: 2, name: '金融业(2)' },
          { value: 1, name: '农业(1)' },
        ],
      },

      charts2: {
        title: '问题类型',
        subTitle: '50个',

        data: [
          { value: 6, name: '市场经营(6)' },
          { value: 8, name: '能源保障(8)' },
          { value: 3, name: '土地资源(3)' },
          { value: 10, name: '资金需求(10)' },
          { value: 9, name: '审批服务(9)' },
          { value: 11, name: '人工用才(11)' },
          { value: 2, name: '政策支持(2)' },
          { value: 1, name: '其他(1)' },
        ],
      },
    }
  },
  mounted() {
    this.initEcharts(this.charts1, 'charts-1')
    this.initEcharts(this.charts2, 'charts-2')
  },
  methods: {
    initEcharts(parameter, $sel) {
      var chartDom = document.getElementById($sel)
      var myChart = echarts.init(chartDom)
      var option

      option = {
        legend: {
          orient: 'vertical',
          type: 'scroll',
          top: 'center',
          left: '65%',
        },

        title: {
          text: parameter.title,
          textStyle: {
            color: '#2FA5F5',
            fontSize: 12,
          },
          subtext: parameter.subTitle,
          subtextStyle: {
            color: '#727171',
            fontSize: 22,
            fontWeight: 'blod',
          },
          textAlign: 'center',
          left: '30%',
          top: 'center', //top待调整
          itemGap: 5, //主副标题间距
        },
        series: [
          {
            name: 'Access From',
            type: 'pie',
            center: ['30%', '50%'],
            radius: ['50%', '90%'],
            data: parameter.data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
            labelLine: {
              show: false,
            },
            label: {
              show: false,
            },
          },
        ],
      }

      option && myChart.setOption(option)
    },
  },
}
</script>

<style>
.qy {
  height: calc(100vh - 170px);
  overflow: auto;
}
.qy1 {
  padding: 25px 0 10px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 0 0 4px 4px;
}
#charts-1 {
  width: 100%;
  height: 220px;
}
.qy2 {
  padding: 20px 0;
  box-sizing: border-box;
  background: #fff;
  border-radius: 4px;
  margin-top: 10px;
  margin-bottom: 20px;
}
#charts-2 {
  width: 100%;
  height: 220px;
}
</style>



// WEBPACK FOOTER //
// src/components/Wjtz-component3.vue